

















































































import locationType from '@/store/types/location';
import { EnterpriceAddress as IntefaceEnterpriceAddress } from '@/store/interfaces/company';
import companyTypes from '@/store/types/company';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { phoneMask } from '@/const/phoneNumber';
import divider from '@/components/Reusable/divider.vue';

export default Vue.extend({
  name: 'EnterpriseAddress',
  components: {
    divider,
  },
  props: {
    update: {
      required: false,
      default: false,
      type: Boolean,
    },
    addressModel: {
      required: false,
      default: () => ({}),
      type: Object as PropType<IntefaceEnterpriceAddress>,
    },
  },
  data: () => ({
    phoneMask,
    isPhoneValid: false,
    e164AddressPhoneNumber: '',
    rawAddressPhone: '',
    address: {
      country_code: '',
      state_code: '',
      phone: '',
      description: '',
    } as IntefaceEnterpriceAddress,
  }),
  computed: {
    ...mapGetters({
      getListState: `country/${locationType.getters.GET_STATE}`,
      getCountry: `country/${locationType.getters.GET_COUNTRY}`,
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
  methods: {
    ...mapMutations({
      setAddress: `companyModule/${companyTypes.mutations.SET_ADDRESS}`,
    }),
    ...mapActions({
      ListState: `country/${locationType.actions.STATE_LIST}`,
    }),
    ...mapActions({
      ListCountry: `country/${locationType.actions.COUNTRY_LIST}`,
    }),
    assignAddress(): void {
      const address = this.update
        ? { ...this.addressModel, }
        : this.getNewCompanyParams.address;

      if (!address.country_code && address.state_code) {
        address.country_code = address.state_code.split('-')[0];
      }
      this.address = address;
      if (address.phone) {
        this.e164AddressPhoneNumber = address.phone;
      }
    },
    onAddressPhoneValidate(phoneObject: unknown): void {
      const validationObject = phoneObject as { isValid?: boolean };
      this.isPhoneValid = validationObject?.isValid ?? false;
    },
    onAddressE164(e164PhoneNumber: string): void {
      this.e164AddressPhoneNumber = e164PhoneNumber;
      this.address.phone = e164PhoneNumber;
    },
  },
  watch: {
    address: {
      immediate: true,
      deep: true,
      handler(val) {
        let phone = (this.e164AddressPhoneNumber || '').replace(/ /g, '');
        if (!phone && val.phone) {
          phone = val.phone;
        }
        const address = {
          ...val,
          phone,
        };
        if (this.update) {
          this.$emit('update:addressModel', address);
        } else {
          this.setAddress(address);
        }
      },
    },
    'address.country_code'(newCode: string, oldCode: string) {
      if (oldCode && newCode !== oldCode) {
        this.address.state_code = '';
      }
      if (newCode) {
        this.ListState(newCode);
      }
    },
  },
  async mounted(): Promise<void> {
    this.assignAddress();
    if (this.address.country_code) {
      await this.ListState(this.address.country_code);
    } else {
      await this.ListState();
    }
    await this.ListCountry();
  },
});
